/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow
import type { Element, Node } from 'react';

import classNames from 'classnames';
import React, { useState } from 'react';
import { Spinner } from 'reactstrap';
import { ActionRowButton } from '#components/support/layout/ActionRow/index.jsx';

type Props = {|
  children: Node,
  className: string,
  handleClick: Function,
|};

const CreateModelButton = ({
  className,
  children,
  handleClick,
}: Props): Element<typeof ActionRowButton> => {
  const [isCreating, setIsCreating] = useState(false);

  const onClick = () => {
    const result = handleClick();
    if (result && typeof result.then === 'function') {
      setIsCreating(true);
      result.finally(() => setIsCreating(false));
    }
  };

  return (
    <ActionRowButton
      className={classNames('create-model-button', className)}
      onClick={onClick}
      disabled={isCreating}
    >
      {isCreating ? <Spinner size="sm" aria-label="Creating model..." /> : children}
    </ActionRowButton>
  );
};

export default CreateModelButton;
